import { Component } from 'react';
import PropTypes from 'prop-types';
import { SalesContentAppContext } from 'SalesContentIndexUI/containers/SalesContentAppContainer';
import SearchResultRecord from 'SalesContentIndexUI/data/records/SearchResultRecord';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import { assertPropsDefined } from '../../utils/PropValidationUtils';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { EditIcon } from 'foundations-assets/icons/components/EditIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class RenameFolderTableActionButton extends Component {
  constructor(...args) {
    super(...args);
    this.openRenameModal = () => {
      // Typecast `this.context` because `declare` can't be used
      // https://git.hubteam.com/HubSpot/asset-bender-hubspot/pull/3245#issuecomment-2444231
      const {
        openRenameFolderModal,
        closeRenameFolderModal
      } = this.context;
      openRenameFolderModal({
        folder: this.props.selectedFolder,
        onConfirm: updatedFolder => {
          closeRenameFolderModal();
          this.props.onRenameSuccess(updatedFolder);
        },
        onReject: closeRenameFolderModal
      });
    };
  }
  render() {
    const {
      selectedFolder,
      onRenameSuccess,
      disabled
    } = this.props;
    assertPropsDefined({
      selectedFolder,
      onRenameSuccess,
      disabled
    });
    return /*#__PURE__*/_jsxs(Button, {
      use: "link",
      onClick: this.openRenameModal,
      disabled: disabled,
      "data-selenium-test": "rename-folder-button",
      children: [/*#__PURE__*/_jsx(IconHolder, {
        icon: EditIcon,
        size: "300",
        padding: "0",
        marginInlineEnd: "50"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "salesContentIndexUI.tableControls.rename"
      })]
    });
  }
}
RenameFolderTableActionButton.contextType = SalesContentAppContext;
RenameFolderTableActionButton.propTypes = {
  selectedFolder: PropTypes.instanceOf(SearchResultRecord).isRequired,
  onRenameSuccess: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};
export default RenameFolderTableActionButton;